"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Progress = exports.TEST_ID_PROGRESS = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var theme_ui_1 = require("theme-ui");
exports.TEST_ID_PROGRESS = "progress";
function Progress(_a) {
    var value = _a.value, max = _a.max, csx = _a.csx;
    var maxValue = max || 100;
    return (theme_ui_1.jsx(theme_ui_1.Progress, { "data-testid": exports.TEST_ID_PROGRESS, sx: csx, max: maxValue, value: value },
        value / maxValue * 100,
        "%"));
}
exports.Progress = Progress;
Progress.defaultProps = {
    max: 100
};
